import { OrgUserRole } from '@app/orgs/services';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  OrgUserPermissionGroup,
  PaginatedContextRequest,
  PaginatedRolesContextResponse,
  RoleMemberResponse,
  SearchResultItem,
} from './_mock-data';

import { NgxHttpClient } from '@app/shared/ngx-http-client';
import { UserService } from '@app/user/services/user.service';
import { UserProfileSummary } from '@app/user/user-api.model';

@Injectable()
export class OrgManageUserPermissionsApiService {
  constructor(
    private http: NgxHttpClient,
    private userService: UserService
  ) {}

  public getUserRoles(
    paginationData: PaginatedContextRequest,
    orgId: number
  ): Observable<PaginatedRolesContextResponse<OrgUserRole>> {
    return this.http.get<PaginatedRolesContextResponse<OrgUserRole>>(
      `/organizations/${orgId}/roles`,
      {
        params: { ...paginationData },
      }
    );
  }

  public getPermissions(): Observable<OrgUserPermissionGroup[]> {
    return this.http.get<OrgUserPermissionGroup[]>('/permissions/categories');
  }
  public getSearchData(query: string): Observable<UserProfileSummary[]> {
    return this.userService.findNetworkMembers(query, false, 3, true);
  }

  public getRoleMembers(
    role: OrgUserRole,
    orgId: number,
    take: number,
    page: number
  ): Observable<RoleMemberResponse> {
    return this.http.get<RoleMemberResponse>(
      `/organizations/${orgId}/roles/${role.roleId}/members`,
      {
        params: {
          take,
          page,
        },
      }
    );
  }

  public upsertRoleAndMembers(
    role: Partial<OrgUserRole>,
    pendingMembers: SearchResultItem[],
    orgId: number
  ) {
    const membersToAdd = pendingMembers.map((x) => ({
      id: x.userProfileKey,
      type: x.type,
    }));

    const isNewRole = role.roleId === null;
    const request = isNewRole
      ? this.http.post(`/organizations/${orgId}/roles`, {
          ...role,
          membersToAdd,
        })
      : this.http.put(`/organizations/${orgId}/roles/${role.roleId}`, {
          ...role,
          membersToAdd,
        });
    return request;
  }

  public deleteRole(orgId: number, roleId: number) {
    return this.http.delete(`/organizations/${orgId}/roles/${roleId}`);
  }
}
